import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SizechartService {


  url = environment.serverAPI4 + "/api/sizechart"; 
  
  constructor(private http: HttpClient) { }

 getAllSizeChart(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

 getAllSizeChartDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }


  getAllSizechartById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  addOrEditSizeChart(sizechart: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, sizechart);
  }

  sizechartSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

}
